<template lang="pug">
.container-restricao.row
    .col-12
        small Foram detectadas as seguintes irregularidades:

        .list-group
            a.list-group-item.list-group-item-action
                .row.text-left
                    label.col-3 Documento

                    label.col-3 Nome fornecedor

                    label.col-3 Propriedade

                    label.col-3 Status

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in dados.restricoes'
            )
                .row.text-left
                    .col-3
                        span {{ restricao.properties.cpf_cnpj }}

                    .col-3
                        span {{ restricao.properties.nome_fornecedor }}

                    .col-3.pr-0
                        .text-wrap(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            :title='restricao.properties.nome_upf'
                        ) {{ restricao.properties.nome_upf }}

                    .col-3
                        span {{ restricao.properties.sts_compra }}
</template>

<script>
export default {
    name: 'ProtocoloVerdeGraos',

    props: {
        dados: {
            type: Object,
            required: true
        }
    },

    mounted() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
        });
    }
};
</script>
